import { Task } from '@agilelab/plugin-wb-builder-catalog';
import { DagStatus } from '@agilelab/plugin-wb-builder-common';
import { GovernanceEntityType } from '@agilelab/plugin-wb-governance-common';
import { createStyles, ListItem, makeStyles, Theme } from '@material-ui/core';
import { FC, useMemo } from 'react';
import { GovernanceEntitiesQueryType } from '../../../../graphql/governanceEntities';
import { useEditorPageContext } from '../../context/useEditorPageContext';
import { ComponentItem } from './ComponentItem';
import { MetricItem } from './MetricItem';
import { PolicyItem } from './PolicyItem';

interface Props {
  task: Task;
  governanceEntities: GovernanceEntitiesQueryType['cgp_governance_entity'];
}

const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      detailWrapper: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(1),
        borderRadius: '4px',
        '&:hover': {
          backgroundColor: theme.palette.bkg.primary,
        },
      },
    }),
  { name: 'TaskListItem' },
);

export const TaskListItem: FC<Props> = ({ task, governanceEntities }) => {
  const { setSelectedTask } = useEditorPageContext();
  const classes = useStyles();
  const policy = useMemo(
    () =>
      governanceEntities.find(
        p =>
          task.governanceEntityId === p.governance_entity_id &&
          task.governanceEntityType === GovernanceEntityType.Policy,
      ),
    [governanceEntities, task.governanceEntityId, task.governanceEntityType],
  );
  const metric = useMemo(
    () =>
      governanceEntities.find(
        p =>
          task.governanceEntityId === p.governance_entity_id &&
          task.governanceEntityType === GovernanceEntityType.Metric,
      ),
    [governanceEntities, task.governanceEntityId, task.governanceEntityType],
  );

  const isValid = !!policy || !!metric || task.status === DagStatus.FAILED;

  return (
    <ListItem
      onClick={() => {
        if (isValid) setSelectedTask(task);
      }}
      className={classes.detailWrapper}
      style={{
        cursor: isValid ? 'pointer' : 'auto',
      }}
    >
      {policy && <PolicyItem policy={policy} task={task} />}
      {metric && <MetricItem metric={metric} task={task} />}
      {!policy && !metric && (
        <ComponentItem
          description={task.displayName ?? task.name}
          componentName={task.componentName}
          status={task.status}
        />
      )}
    </ListItem>
  );
};
